import React, {FC, useMemo} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {TeammateModel} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {
  buildTeammateDisplayName,
  buildTeammateShortDisplayName,
} from '../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {
  ItemsFormatter,
  NameDecorator,
  OthersTextDecorator,
} from '../../../../srcCommon/formatters/itemsFormatter';

/*
 * Props.
 */

interface TeammatesFormatterProps {
  /** The teammates to render. */
  teammates: ReadonlyArray<TeammateModel>;
  /** The maximum number of names to display. */
  limit?: number;
  /** ID of the teammate to render as 'You'. */
  userId?: number;
  /** Default is to show full name for teammates. */
  showFirstNameOnly?: boolean;
  /** Render teammate name. */
  renderTeammateName?: NameDecorator;
  /** Render "X others" text. */
  renderOthersText?: OthersTextDecorator;
}

/*
 * Component.
 */

export const TeammatesFormatter: FC<TeammatesFormatterProps> = (props) => {
  const {teammates, userId, showFirstNameOnly} = props;
  const items = useMemo(
    () =>
      teammates.map((teammate) => {
        if (teammate.id === userId) {
          return {id: teammate.id, name: <Trans id="teammatesFormatter-you">you</Trans>};
        }

        if (showFirstNameOnly) {
          return {id: teammate.id, name: buildTeammateShortDisplayName(teammate)};
        }

        return {id: teammate.id, name: buildTeammateDisplayName(teammate)};
      }),
    [teammates, userId, showFirstNameOnly],
  );
  return (
    <ItemsFormatter
      items={items}
      limit={props.limit}
      renderName={props.renderTeammateName}
      renderOthersText={props.renderOthersText}
    />
  );
};
